const urlCreator = {
    companyProfile: (companyId) => `/companies/profile?companyId=${companyId}` 
};

export default urlCreator;